document.addEventListener('DOMContentLoaded', function () {

    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  if (!document.documentElement.hasAttribute('data-scheme')) {
    document.documentElement.setAttribute('data-scheme', prefersDark ? 'dark' : 'light');
  }

  const trigger = document.querySelector('.stock-toggle-button');
  const content = document.querySelector('.stock-branches-wrapper');
  const toggleIcon = trigger?.querySelector('.toggle-icon');
  const branchGroup = document.getElementById('stock-branch-group');
  const translationContainer = document.getElementById('stock-translations');

  if (!branchGroup || !translationContainer) return;

  let isOpen = false;
  let currentRotation = 0;
  let realContent = '';
  let dataLoaded = false;
  let skeletonTimeout = null;
  let realContentTimeout = null;
  let lastRequest = 0; // ძველი (დაგვიანებული) პასუხი ახალს რომ არ გადაეწეროს

  const nameTbilisiMall = translationContainer.dataset.nameTbilisiMall || 'Tbilisi Mall';
  const addrTbilisiMall = translationContainer.dataset.addrTbilisiMall || '';
  const nameVake = translationContainer.dataset.nameVake || 'Vake';
  const addrVake = translationContainer.dataset.addrVake || '';
  const textAvailable = translationContainer.dataset.stockAvailableQty || '{{ count }} In Stock';
  const textUnavailable = translationContainer.dataset.stockUnavailable || 'Out of stock';

  // ბანდლს კოდი თავად ამოიცნობს Shopify-დან (Bundled products) — სახელი/template არ სჭირდება

  window.lastRenderedVariantId = window.currentVariantIdFromLiquid || getVariantIdFromUrl();

function updateTotalInventoryCount(data) {
  const statusContainer = document.getElementById('inventory-status');
  if (!statusContainer || !data || !data.branches) return;

  const total = data.branches.reduce((sum, b) => sum + b.available, 0);

  const iconCheck = document.getElementById('icon-check')?.innerHTML || '';
  const iconBell = document.getElementById('icon-bell')?.innerHTML || '';
  const iconUnavailable = document.getElementById('icon-unavailable')?.innerHTML || '';

  let iconHtml = '';
  let messageHtml = '';
  let extraClass = '';

  if (total >= 10) {
    iconHtml = iconCheck;
    messageHtml = `მარაგში <span id="total-stock-quantity">${total}</span> ცალი`;
    extraClass = ''; // normal
  } else if (total > 0) {
    iconHtml = iconBell;
    messageHtml = `მარაგშია <span id="total-stock-quantity">${total}</span> ცალი`;
    extraClass = 'product__inventory-inner--error'; // highlight
  } else {
    iconHtml = iconUnavailable;
    messageHtml = `არ არის მარაგში`;
    extraClass = 'product__inventory-inner--empty'; // red / empty
  }

  statusContainer.className = `product__inventory-inner bold ${extraClass}`;
  statusContainer.innerHTML = iconHtml + '<span class="translated-stock-line">' + messageHtml + '</span>';
}


function escapeHtml(str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
}


/* ---------- ბანდლი: კომპონენტების მოძებნა და მარაგის დათვლა ---------- */

const componentsCache = {}; // variantId -> Promise<[{ id, qty }]>
const COMP_CACHE_KEY = 'dkhl-comp1:';
const COMP_CACHE_MS = 60 * 60 * 1000; // 1 საათი

// ბანდლის ვარიანტის შემადგენელი ვარიანტები. ჩვეულებრივ პროდუქტზე — ცარიელი სია.
// შედეგი ბრაუზერში 1 საათით ინახება, ამიტომ ზედმეტი მოთხოვნა არ იგზავნება.
function getBundleComponents(variantId) {
  if (componentsCache[variantId]) return componentsCache[variantId];

  try {
    const o = JSON.parse(localStorage.getItem(COMP_CACHE_KEY + variantId));
    if (o && Array.isArray(o.d) && Date.now() - o.t < COMP_CACHE_MS) {
      componentsCache[variantId] = Promise.resolve(o.d);
      return componentsCache[variantId];
    }
  } catch (e) {}

  componentsCache[variantId] = loadBundleComponents(variantId).then(list => {
    if (list) {
      try { localStorage.setItem(COMP_CACHE_KEY + variantId, JSON.stringify({ t: Date.now(), d: list })); } catch (e) {}
    } else {
      delete componentsCache[variantId]; // შემდეგ ჯერზე ხელახლა ვცდით
    }
    return list || [];
  });
  return componentsCache[variantId];
}

// Shopify Storefront API
async function loadBundleComponents(variantId) {
  const query =
    'query($id:ID!){node(id:$id){... on ProductVariant{' +
      'components(first:10){nodes{quantity productVariant{id}}}' +
    '}}}';

  try {
    const res = await fetch('/api/2025-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ query, variables: { id: 'gid://shopify/ProductVariant/' + variantId } })
    });
    const json = await res.json();
    if (!json || !json.data) return null; // შეცდომა — არ ვინახავთ, შემდეგ ჯერზე ხელახლა ვცდით
    const nodes = json.data.node?.components?.nodes || [];
    return nodes
      .filter(n => n && n.productVariant && n.productVariant.id)
      .map(n => ({
        id: String(n.productVariant.id).split('/').pop(),
        qty: Math.max(1, n.quantity || 1)
      }));
  } catch (e) {
    return null;
  }
}

// ერთი ვარიანტის მარაგი ფილიალების მიხედვით (თქვენი dashboard API)
async function fetchStockData(variantId) {
  const url = `https://dashboard.dakhli.ge/api/stock-branches/variant/${variantId}`;

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Accept-Language': document.documentElement.lang || 'ka'
    }
  });

  const rawText = await res.text();

  let data;
  try {
    data = rawText ? JSON.parse(rawText) : {};
  } catch (parseErr) {
    throw new Error(`Response is not valid JSON. Status: ${res.status}. Body: ${rawText}`);
  }

  if (!res.ok) {
    throw new Error(data?.error || `Invalid server response (${res.status})`);
  }

  if (!data.branches || !Array.isArray(data.branches)) {
    throw new Error('branches array is missing in response');
  }

  return data;
}

// ბანდლის მარაგი თითოეულ ფილიალში = კომპონენტების მარაგებს შორის უმცირესი
// (თუ კომპონენტი ბანდლში 2 ცალია, მისი მარაგი 2-ზე იყოფა)
function combineBundleStock(datas, comps) {
  const base = datas[0];
  const branches = base.branches.map(branch => {
    let available = Infinity;
    datas.forEach((d, i) => {
      const match = d.branches.find(b => b.name === branch.name);
      const avail = match ? Math.max(0, Number(match.available) || 0) : 0;
      available = Math.min(available, Math.floor(avail / comps[i].qty));
    });
    if (!isFinite(available)) available = 0;
    return Object.assign({}, branch, { available, isAvailable: available > 0 });
  });
  return Object.assign({}, base, { branches });
}

// ჩვეულებრივ პროდუქტზე — პირდაპირ; ბანდლზე — კომპონენტებიდან
async function getStock(variantId) {
  const comps = await getBundleComponents(variantId);
  if (comps.length) {
    const datas = await Promise.all(comps.map(c => fetchStockData(c.id)));
    return combineBundleStock(datas, comps);
  }
  return fetchStockData(variantId);
}


async function fetchAndRenderStock(variantId, showSkeleton = false) {
  if (!variantId) {
    branchGroup.innerHTML = `<div class="stock-error">ვარიანტის ID ვერ მოიძებნა</div>`;
    return;
  }

  const requestId = ++lastRequest;
  dataLoaded = false;

  if (showSkeleton) {
    branchGroup.innerHTML = `
      <div id="skeleton-block">
        <div class="stock-branch-item grouped skeleton">
          <div class="stock-branch-info skeleton">
            <span class="skeleton-line long"></span>
            <span class="skeleton-line medium"></span>
            <span class="skeleton-line short"></span>
          </div>
        </div>
        <div class="stock-branch-item grouped skeleton">
          <div class="stock-branch-info skeleton">
            <span class="skeleton-line long"></span>
            <span class="skeleton-line medium"></span>
            <span class="skeleton-line short"></span>
          </div>
        </div>
      </div>
    `;
    content.style.maxHeight = content.scrollHeight + 'px';
  }

  try {
    const data = await getStock(variantId);

    // ამასობაში სხვა ვარიანტი აირჩიეს — ეს პასუხი უკვე მოძველებულია
    if (requestId !== lastRequest) return;

    realContent = data.branches
      .filter(branch => !branch.name.includes('Vake'))
      .map(branch => {
        let name = escapeHtml(branch.name);
        let address = escapeHtml(branch.address);
        let phone = (branch.phone || '').replace(/\s/g, '');

        if (name.includes('Tbilisi Mall')) {
          name = nameTbilisiMall;
          address = addrTbilisiMall;
          phone = '505 555 256';
        } else if (name.includes('Vake')) {
          name = nameVake;
          address = addrVake;
          phone = '505 555 256';
        }

        const statusText = branch.isAvailable
          ? textAvailable.replace('{{ count }}', branch.available)
          : textUnavailable;

        return `
          <div class="stock-branch-item grouped">
            <div class="stock-branch-info">
              <div class="stock-branch-title-line">
                <a href="${escapeHtml(branch.mapsUrl)}" target="_blank" class="stock-branch-name">${name}</a>
                <span class="dot-separator">•</span>
                <a href="tel:${phone}" class="stock-branch-phone">${phone}</a>
              </div>
              <div class="stock-branch-address">${address}</div>
              <span class="stock-status ${branch.isAvailable ? '' : 'stock-status--out'}">
                <span class="stock-dot ${branch.isAvailable ? '' : 'stock-dot--out'}"></span>
                ${statusText}
              </span>
            </div>
          </div>
        `;
      }).join('');

    dataLoaded = true;
    updateTotalInventoryCount(data);

    if (isOpen) {
      skeletonTimeout = setTimeout(() => {
        branchGroup.innerHTML = `<div class="fade-in">${realContent}</div>`;
        realContentTimeout = setTimeout(() => {
          content.style.maxHeight = content.scrollHeight + 'px';
        }, 50);
      }, 500);
    } else {
      branchGroup.innerHTML = `<div class="fade-in">${realContent}</div>`;
    }

  } catch (err) {
    if (requestId !== lastRequest) return;
    branchGroup.innerHTML = `<div class="stock-error">სტატუსის ჩატვირთვა ვერ მოხერხდა</div>`;
  }
}


  function getVariantIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function watchVariantChangeFromUrl() {
    setInterval(() => {
      const urlVariantId = getVariantIdFromUrl();
      if (urlVariantId && urlVariantId !== window.lastRenderedVariantId) {
        window.lastRenderedVariantId = urlVariantId;
        fetchAndRenderStock(urlVariantId, isOpen);
      }
    }, 400);
  }

  trigger?.addEventListener('click', () => {
    isOpen = !isOpen;
    currentRotation += 180;
    clearTimeout(skeletonTimeout);
    clearTimeout(realContentTimeout);

    if (isOpen) {
      fetchAndRenderStock(window.lastRenderedVariantId, true);
      content.style.maxHeight = content.scrollHeight + 'px';
      trigger.classList.add('open');
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      setTimeout(() => {
        content.style.maxHeight = '0';
      }, 10);
      trigger.classList.remove('open');
    }

    toggleIcon.style.transform = `rotate(${currentRotation}deg)`;
  });

  fetchAndRenderStock(window.lastRenderedVariantId);
  watchVariantChangeFromUrl();
});